import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { InlineToolbar } from 'content-assistance-lib/toolbars/InlineToolbar';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { insertContent } from 'hubspot-prosemirror/prosemirror/utils/documentUtils';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
function getEditorContextPromptForAI(editorState) {
  // in case user select all (ctrl + a), `from` will be 0, and
  // insertion should be from 1 NOT 0.
  const from = Math.max(1, editorState.selection.from);
  const to = editorState.selection.to;
  const beforeSelection = editorState.doc.textBetween(0, from, '\n');
  const processedSelection = `<<${editorState.doc.textBetween(from, to, '\n')}>>`;
  const afterSelection = editorState.doc.textBetween(to, editorState.doc.content.size, '\n');
  return `${beforeSelection}${processedSelection}${afterSelection}`;
}
export default function ContentAssistantHighlightButton({
  view,
  onOpenDropdown,
  pluginKey,
  usageDescription,
  selectionCommands,
  trackInteraction
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const pluginState = pluginKey.getState(view.state);
  const editorContext = getEditorContextPromptForAI(editorState);
  const onClose = () => {
    view.dispatch(view.state.tr.setMeta(pluginKey, {
      widgetOpened: false,
      from: view.state.selection.from,
      to: view.state.selection.to
    }));
  };
  const onTextChange = text => {
    const html = `${text.replaceAll('\n', '<br>')}`;
    const newState = insertContent({
      htmlBody: html,
      editorState: view.state,
      from: Math.max(1, editorState.selection.from),
      to: editorState.selection.to
    });
    setEditorState(newState);
  };
  return /*#__PURE__*/_jsx(UIPopover, {
    open: pluginState && pluginState.widgetOpened,
    onOpenChange: onOpenDropdown,
    use: 'unstyled',
    placement: "bottom right",
    "data-test-id": 'content-assistant-highlight-popover',
    content: {
      body: /*#__PURE__*/_jsx(InlineToolbar, {
        selectionCommands: selectionCommands,
        onClosePopover: onClose,
        onTextChange: onTextChange,
        editorContext: editorContext,
        usageDescription: usageDescription,
        trackInteraction: trackInteraction
      })
    },
    children: pluginState && pluginState.widgetOpened ? /*#__PURE__*/_jsx("span", {}) : /*#__PURE__*/_jsx(UIIconButton, {
      shape: "circle",
      placement: "right",
      size: "small",
      onClick: onOpenDropdown,
      "data-test-id": 'content-assistant-highlight-trigger-button',
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "artificialIntelligence"
      })
    })
  });
}